var _circle, _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBluelist(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group 1000006084"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1005",
    cx: 35.5,
    cy: 35.5,
    r: 35.5,
    fill: "#F1F8FF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "feed"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_515_4970",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 18,
    width: 35,
    height: 35
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    x: 18,
    y: 18,
    width: 35,
    height: 35,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_515_4970)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "feed_2",
    d: "M25.2917 48.625C24.4896 48.625 23.803 48.3394 23.2318 47.7682C22.6606 47.1971 22.375 46.5104 22.375 45.7083V25.2917C22.375 24.4896 22.6606 23.803 23.2318 23.2318C23.803 22.6606 24.4896 22.375 25.2917 22.375H41.3333L48.625 29.6667V45.7083C48.625 46.5104 48.3394 47.1971 47.7682 47.7682C47.1971 48.3394 46.5104 48.625 45.7083 48.625H25.2917ZM25.2917 45.7083H45.7083V31.125H39.875V25.2917H25.2917V45.7083ZM28.2083 42.7917H42.7917V39.875H28.2083V42.7917ZM28.2083 31.125H35.5V28.2083H28.2083V31.125ZM28.2083 36.9583H42.7917V34.0417H28.2083V36.9583Z",
    fill: "#27447C"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBluelist);
export default __webpack_public_path__ + "static/media/bluelist.d691baeba92358d9ab3fcf21b5a9ab7b.svg";
export { ForwardRef as ReactComponent };